module.exports = __webpack_public_path__ + "static/img/twjd-sdr1.66e68c5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/twjd-sdr1.png
// module id = 866
// module chunks = 0